export default __webpack_public_path__ + "static/media/kiril_l.3a6b084a.jpg";